import { isSystemPipelineId } from 'app/components/action-center/systemPipelines'
import type { PipelineType } from 'app/types/entities'

/**
 * A filter list's stages live on a real pipeline record the API knows nothing special
 * about. The name is the marker: `Pipeline` has no other field to carry one, and a name
 * nobody would type keeps the record out of every list of pipelines a person sees.
 */
export const COMPANION_PREFIX = `list:`

export function companionPipelineName(customPageId: string): string {
  return `${COMPANION_PREFIX}${customPageId}`
}

export function isCompanionPipeline(pipeline: Pick<PipelineType, `name`>): boolean {
  return !!pipeline.name && pipeline.name.startsWith(COMPANION_PREFIX)
}

export function companionFor(customPageId: string, pipelines: readonly PipelineType[]): PipelineType | undefined {
  const name = companionPipelineName(customPageId)
  return pipelines.find((pipeline) => pipeline.name === name)
}

/**
 * The memberships a contact's list surfaces draw, count and overflow. A companion is never
 * one; with `hideSystem`, neither is a system membership, whose rule row already shows its
 * stage. Display only: a write still sends the whole array, these included.
 */
export function visibleMemberships<T extends { id: string }>(
  memberships: readonly T[],
  pipelines: readonly Pick<PipelineType, `id` | `name`>[],
  { hideSystem }: { hideSystem: boolean },
): T[] {
  const companionIds = new Set(
    pipelines.filter((pipeline) => isCompanionPipeline(pipeline)).map((pipeline) => pipeline.id),
  )
  return memberships.filter(
    (membership) => !companionIds.has(membership.id) && !(hideSystem && isSystemPipelineId(membership.id)),
  )
}
